import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { Checkbox, ListItemButton, Typography } from "@mui/material"
import { ListItemBox } from "lib/@components/ListItemBox"
import { useReferenceState } from "lib/@hooks/use-reference"

export function FilterLabel({ item, type }) {
    const { target } = useBoundContext()
    const [filters, setFilters] = useReferenceState("asset-filters" + target.id, {})

    const selected = !!filters[type]?.find((t) => t === item)
    return (
        <ListItemButton selected={selected} onClick={set} tabIndex={-1}>
            <ListItemBox spacing={0.5}>
                <Checkbox
                    size="small"
                    checked={selected}
                    data-cy={`register-filter-checkbox-${item?.toLowerCase().split(" ").join("-")}`}
                />
                <Typography variant="body2">{item}</Typography>
            </ListItemBox>
        </ListItemButton>
    )

    function set() {
        setFilters((filters) => {
            filters = { ...filters }

            let current = filters[type] ?? []
            if (current.some((c) => c === item)) {
                current = current.filter((c) => c !== item)
            } else {
                current = [...current, item].unique()
            }
            filters[type] = current
            if (filters[type].length === 0) delete filters[type]
            return filters
        })
    }
}
